import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider } from '../../base/AdminContext';
import AdminLoginPage from '../pages/admin/AdminLoginPage';
import AdminDashboardPage from '../pages/admin/AdminDashboardPage';
import { TripsManagementPage } from '../pages/admin/TripManagement/TripsManagementPage';


import { RolesManagementPage } from '../pages/admin/RoleManagement/RolesManagementPage';
import AdminsManagementPage from '../pages/admin/AdminManagement/AdminsManagementPage';

import PublicVouchersPage from '../pages/admin/VoucherManagement/PublicVouchersPage';
import PrivateVouchersPage from '../pages/admin/VoucherManagement/PrivateVouchersPage';
import VoucherRewardPage from '../pages/admin/VoucherManagement/VoucherRewardPage';
import VoucherCodeRandomPage from '../pages/admin/VoucherManagement/VoucherCodeRandomPage';

import { MotorbikePricingPage } from '../pages/admin/PricingManagement/MotorbikePricingPage';
import { Car4SeatPricingPage } from '../pages/admin/PricingManagement/Car4SeatPricingPage';
import { Car7SeatPricingPage } from '../pages/admin/PricingManagement/Car7SeatPricingPage';
import { DriversManagementPage } from '../pages/admin/DriverManagement/DriversManagementPage';
import { UsersManagementPage } from '../pages/admin/UserManagement/UsersManagementPage';
import { BannersManagementPage } from '../pages/admin/BannersManagement/BannersManagementPage';
import { NewsManagementPage } from '../pages/admin/NewsManagement/NewsManagementPage';
import { SystemConfigurationManagementPage } from '../pages/admin/SystemConfiguration/SystemConfigurationManagementPage';
import { NotificationsManagementPage } from '../pages/notifications/NotificationsManagementPage';



export const AdminApp: React.FC = () => {
    return (
        <AdminProvider>
            <Routes>
                <Route path="/login" element={<AdminLoginPage />} />
                <Route path="/dashboard" element={<AdminDashboardPage />} />
                <Route path="/trips" element={<TripsManagementPage />} />
                {/* <Route path="/drivers/inactive" element={<DriversManagementPage type="inactive" />} />
              
                {/* <Route path="/drivers" element={<Navigate to="/admin/drivers/active" replace />} /> */}
                <Route path="/drivers" element={<DriversManagementPage />} />
                <Route path="/users" element={<UsersManagementPage />} />
                <Route path="/roles" element={<RolesManagementPage />} />
                <Route path="/admins" element={<AdminsManagementPage />} />
                <Route path="/vouchers/public" element={<PublicVouchersPage />} />
                <Route path="/vouchers/private" element={<PrivateVouchersPage />} />
                <Route path="/vouchers/reward" element={<VoucherRewardPage />} />
                <Route path="/vouchers/random-code" element={<VoucherCodeRandomPage />} />
                <Route path="/pricing/motorbike" element={<MotorbikePricingPage />} />
                <Route path="/pricing/car-4seat" element={<Car4SeatPricingPage />} />
                <Route path="/pricing/car-7seat" element={<Car7SeatPricingPage />} />
                <Route path="/banners" element={<BannersManagementPage />} />
                <Route path="/news" element={<NewsManagementPage />} />
                <Route path="/notifications" element={<NotificationsManagementPage />} />
                <Route path="/system-configuration" element={<SystemConfigurationManagementPage />} />
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path="*" element={<Navigate to="/admin/login" replace />} />

            </Routes>
        </AdminProvider>
    );
};
